import { render, staticRenderFns } from "./setNdrcPrice.vue?vue&type=template&id=6fc6ed30&scoped=true&"
import script from "./setNdrcPrice.vue?vue&type=script&lang=js&"
export * from "./setNdrcPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6ed30",
  null
  
)

export default component.exports